import React, { FC } from 'react';
import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Input } from '../../../system/components/Input';

interface Props {
  form: WrappedFormUtils;
  initialValue?: string;
}

export const InputState: FC<Props> = ({ form, initialValue }): JSX.Element => (
  <Form.Item label="State:">
    {form.getFieldDecorator('state', {
      initialValue,
      rules: [{ message: 'Please enter the location state.', required: true }],
    })(<Input allowClear placeholder="State" />)}
  </Form.Item>
);
